import { ROUTES } from "@/@core/constants/routes";
import { useMemo } from "react";

const useSearchPages = () => {
  const searchPages = useMemo(() => {
    return [ROUTES.CAMPAIGNS, ROUTES.EVENTS];
  }, []);

  return searchPages;
};

export default useSearchPages;
